export const tagEntity = Object.freeze({
  label: {
    en: '',
    sv: '',
    fi: '',
  },
})
